/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Apply_Planning_WarningInputs */



/**
* | output |
* | --- |
* | "User plannings already present in the selected rooms will be deleted" |
*
* @param {Apply_Planning_WarningInputs} inputs
* @param {{ locale?: "fr" | "en" }} options
* @returns {LocalizedString}
*/
export const apply_planning_warning = /** @type {((inputs?: Apply_Planning_WarningInputs, options?: { locale?: "fr" | "en" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Apply_Planning_WarningInputs, { locale?: "fr" | "en" }, {}>} */ ((inputs = {}, options = {}) => {
	void inputs;
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "en") return /** @type {LocalizedString} */ ("User plannings already present in the selected rooms will be deleted")
	return /** @type {LocalizedString} */ ("Les plannings utilisateurs déjà présents dans les pièces sélectionnées seront supprimés")
});